import React from 'react';

const PopupBlockerWarning = () => (
    <div>
        <p>It appears you have a pop-up blocker on that kept the video player from launching.</p>
        <p>Please allow pop-ups from www.espn.com in your browser settings
        or contact Customer Care at 888-549-ESPN if you need assistance.</p>
    </div>
);

export default PopupBlockerWarning;



// WEBPACK FOOTER //
// ./app/webapp/modal/messaging/PopUpBlockerWarning.js